<div class="create">
    <form [formGroup]="form" [ngxsFormDebounce]="0" ngxsForm="permitTeam.newPermitTeamTextMemberForm" class="create__form" *transloco="let t; read:'permit.team.createPerson'">
        <ng-container>
            <ha-input class="create__form__field" formControlName="member" [label]="t('text')" [readOnlyOnDisabled]="true"></ha-input>
            
            <button class="create__form__button" [ngClass]="form.valid ? 'create__form__button--create' : 'create__form__button--disabled'"
                    [disabled]="!form.valid" (click)="createTeamMember()">{{t('create')}}</button>
        </ng-container>
    </form>
<!-- 
        <div *ngIf="createdPersonName" class="create__information">
            <div [innerHtml]="t('postInformation.line', { name: createdPersonName })"></div>
        </div> -->
   
</div>
